"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCssVariables = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extractCssVariables = require("./extractCssVariables");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Cache state
var cachedResult = null;
var cachedElement = null;
var isObserverSetup = false;
/**
 * 🎯 Gets CSS variables from DOM with smart auto-invalidating cache.
 * Extracts variables from #css-variables element and removes '--' prefix.
 * Cache automatically clears when DOM changes - fully self-contained! 🚀
 *
 * @returns Object with CSS variable names and values
 */

var getCssVariables = function getCssVariables() {
  var element = document.getElementById('css-variables'); // Setup cache invalidation if needed

  if (!isObserverSetup || cachedElement !== element) {
    setupCacheInvalidation();
    cachedElement = element;
    cachedResult = null;
  } // Return cached result if valid


  if (cachedResult && cachedElement === element) {
    return cachedResult;
  } // Extract and transform variables


  var styleSheet = element instanceof HTMLStyleElement ? element.sheet : null;
  var extractedVariables = (0, _extractCssVariables.extractCssVariables)(styleSheet);
  var result = {};

  for (var key in extractedVariables) {
    if (Object.prototype.hasOwnProperty.call(extractedVariables, key)) {
      var cleanKey = key.startsWith('--') ? key.slice(2) : key;
      result[cleanKey] = extractedVariables[key];
    }
  }

  cachedResult = result;
  return result;
};
/**
 * Sets up cache invalidation observer for the css-variables element.
 */


exports.getCssVariables = getCssVariables;

function setupCacheInvalidation() {
  if (isObserverSetup) return;

  var clearCache = function clearCache() {
    cachedResult = null;
    cachedElement = null;
  };

  var observer = new MutationObserver(function (mutations) {
    var _iterator = _createForOfIteratorHelper(mutations),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;

        // Element added/removed
        if (mutation.type === 'childList') {
          var hasTargetElement = [].concat((0, _toConsumableArray2.default)(mutation.addedNodes), (0, _toConsumableArray2.default)(mutation.removedNodes)).some(function (node) {
            return node instanceof Element && node.id === 'css-variables';
          });

          if (hasTargetElement) {
            clearCache();
            break;
          } // Check if content changed within css-variables element


          var target = mutation.target;

          if (target.id === 'css-variables') {
            clearCache();
            break;
          }
        } // Content changed inside css-variables element


        if (mutation.type === 'characterData') {
          var _target = mutation.target.parentElement;

          if ((_target === null || _target === void 0 ? void 0 : _target.id) === 'css-variables') {
            clearCache();
            break;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }); // Observe document.head where css-variables element typically lives

  observer.observe(document.head, {
    childList: true,
    subtree: true,
    characterData: true
  });
  isObserverSetup = true;
}